<template>
	<c-modal @close="close" :title="title">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<div v-if="edit == false">
				<h6 class="margin-t-40">Eindklant</h6>

				<c-select
					:horizontal="true"
					:label="'Naam'"
					:options="endcustomers"
					:required="false"
					v-model="client_id"
					name="client_id"
					:DisplayName="'name'"
					:ValueName="'id'"
					@change="getBundles(client_id)"
				/>
			</div>

			<h6 class="margin-t-40">Artikel</h6>

			<c-input
				:label="'Artikelomschrijving'"
				:horizontal="true"
				type="text"
				name="name"
				v-model="articleDescription"
				required
				/>

			<c-select
				:label="'Voorraadgroep'"
				:horizontal="true"
				:options="product_group"
				:required="true"
				v-model="product_group_id"
				name="product_group_id"
				:DisplayName="'name'"
				:ValueName="'id'"
			/>

            <c-input
				:label="'Artikelnummer'"
				:horizontal="true"
				type="text"
				name="article_number"
				v-model="articleNumber"
				required
			/>

            <c-input
				:label="'Uniek Product ID'"
				:horizontal="true"
				type="text"
				name="unique_product_id"
				v-model="uniqueProductID"
				required
			/>

			<c-textarea
				:label="'Omschrijving'"
				:horizontal="true"
				type="text"
				name="description"
				v-model="description"
			/>

            <c-input
				:horizontal="true"
				:label="'EOL'"
				type="number"
				v-model="eol"
				name="eol"
				placeholder="in aantal maanden"/>

			<c-input
				@change="uploadFile"
				:label="'Afbeelding'"
				:horizontal="true"
				type="file"
				accept="image/*"
				name="_image"
				v-model="stockImage"
				ref="file"
			/>

			<div v-if="client_id">

				<h6 class="margin-t-40">Aan een bundel toevoegen?</h6>

				<c-select
					:horizontal="true"
					:label="'Bundelsomschrijving'"
					:options="bundles"
					:required="true"
					v-model="bundle_id"
					name="name"
					:ValueName="'id'"
				/>

				<a @click="addBundle" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
					<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
					<span>Nieuwe bundel toevoegen</span>
				</a>

				<div v-if="bundleCount == 1">
					<h6 class="c-text-icon margin-t-24 margin-b-16">
						Nieuwe bundel
						<svg @click="deleteItem" class="cursor-pointer color-gray-600 margin-l-8" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
					</h6>

					<c-input
						:label="'Bundelnaam'"
						:horizontal="true"
						type="text"
						name="bundle_name"
						v-model="bundle_name"
						required
					/>

					<div class="row collapse align-right">
						<div class="columns shrink">
							<c-button class="margin-t-32 margin-b-16 no-margin-b" @click="newBundle">Bundel toevoegen</c-button>
						</div>
					</div>
				</div>
			</div>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">{{edit ? "Voorraad wijzigen" : "Voorraad toevoegen"}}</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
	data() {
		return {
			product_group: '',
			product_group_id: '',
			stockGroup: '',
			endcustomers: '',
			eol: '',
            bundleDescription: '',
			bundles: '',
			client_id: '',
			articleDescription: '',
			articleNumber: '',
			uniqueProductID: '',
			description: '',
			bundle_id: '',
			stockImage: null,
			bundleCount: 0,
			name: '',
			bundle_name: '',
		};
	},
	props: {
		edit: {
			required: false,
			default: false
		},
		item: {
			required: false
		},
		title: {
			required: false,
			default: "Nieuw voorraad"
		},
	},
	watch: {
	},
	methods: {
		uploadFile(event) {
        	 let files = Array.from(event.target.files);
			 this.stockImage = files[0];
      	},
		submit() {

			let data = {
                client_id: this.client_id,
                name: this.articleDescription,
                product_group_id: this.product_group_id,
				article_number: this.articleNumber,
				unique_product_id: this.uniqueProductID,
				description: this.description,
                eol: this.eol,
                bundle_id: this.bundle_id,

				bundle_name: this.bundle_name
            };

			if(this.stockImage){
				data.image = this.stockImage;
			}

			if(this.edit)
			{
				data.id = this.item.id;
				data._method = 'PUT';
				this.$xhr.post('/api/products/' + this.item.id, data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Voorraad aanpassen', text: 'De voorraad is aangepast'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Voorraad aanpassen', text: 'Er is helaas iets fout gegaan bij het aanpassen van de voorraad'});
				});
			}
			else{
				this.$xhr.post('/api/products', data).then( ( {result}) => {
					this.$store.dispatch('toast/success', {title: 'Voorraad aanmaken', text: 'De voorraad is aangemaakt'});
					this.close();
					this.$emit('added');
					this.client_id = '';
					this.product_group_id = '';
					this.$refs.form.reset();
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Voorraad aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van de voorraad'});
				});
			}

		},
		addBundle(){
			this.bundleCount = 1;
		},
		deleteItem(){
			this.bundleCount = 0;
		},
		close() {
			this.$emit('close');
		},
		getBundles(client_id){
			this.$xhr.get('/api/clients/' + client_id).then( ( {result}) => {
				this.bundles = result.bundles;

			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Bundels kunnen niet worden ingeladen'});
			});
		},
		newBundle(){

			let data = {
				name: this.bundle_name,
				client_id: this.client_id
			}

			this.$xhr.post('/api/bundles', data).then( ( {result}) => {
				this.$store.dispatch('toast/success', {title: 'Bundel aanmaken', text: 'De bundel is aangemaakt'});

				this.bundleCount = 0;
				this.getBundles(result.client_id);
				this.bundle_id = result.id;
				this.bundle_name = '';
			}).catch( (e) => {
				if (e instanceof ValidationError) {
					this.$refs.form.setErrors(e.errors);
				}
				this.$store.dispatch('toast/alert', {title: 'Bundel aanmaken', text: e.result.errors.name.toString()});
			});
		}
	},
	mounted() {
		this.$xhr.get('/api/product-groups').then( ( {result}) => {
				this.product_group = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Productgroepen kunnen niet worden ingeladen'});
		});

		this.$xhr.get('/api/getallendcustomers').then( ( {result}) => {
				this.endcustomers = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klanten kunnen niet worden ingeladen'});
		});

		if(this.edit)
		{
			this.client_id = this.item.client_id;
			this.articleDescription = this.item.name;
			this.product_group_id = this.item.product_group_id;
			this.articleNumber = this.item.article_number;
			this.uniqueProductID = this.item.unique_product_id;
			this.description = this.item.description;
			this.eol = this.item.eol;
			if (!this.edit) {
				this.bundles = this.item.client.bundles;
			}
		}
	}
}
</script>
